import { connect } from "react-redux";

import { SmallQuantityTicket } from "../../interface/api/SmallQuantityTicket";
import smallQuantityTicketService from "../../services/smallQuantityTicketService";
import { useDigitalTicket } from "../../hooks/useDigitalTicket";
import TicketLoading from "../shared/ticket-loading";
import SmallQuantityPrintableTicket from "./small-quantity-printable-ticket";

/**
 * /small-quantity-digital-ticket/:id - the printable ticket, staff only, the
 * small-quantity counterpart to components/digital-ticket. Read-only by design:
 * every edit path lives on /small-quantity/:id.
 */
const SmallQuantityDigitalTicketView = () => {
  const { ticket, ticketUrl, haulRecordUrl } =
    useDigitalTicket<SmallQuantityTicket>(
      smallQuantityTicketService,
      "small-quantity",
      "small-quantity-haulage-record"
    );

  if (!ticket) return <TicketLoading />;

  return (
    <SmallQuantityPrintableTicket
      ticket={ticket}
      ticketUrl={ticketUrl}
      haulRecordUrl={haulRecordUrl}
    />
  );
};

export default connect()(SmallQuantityDigitalTicketView);
